// @ts-nocheck
import { initialState } from './reducer';

const obsSelector = (state) => state.orderBySku || initialState;

export const getObsColumns = (state) => {
	const { sku, store, warehouse, order } = obsSelector(state).columns;
	return { skuColumns: sku, storeColumns: store, warehouseColumns: warehouse, orderColumns: order || [] };
};

export const getObsOrderData = (state) => obsSelector(state).orderData;

export const getObsAvailability = (state) => obsSelector(state).availability;

export const getObsLoading = (state) => obsSelector(state).loading;
